export const ROUTES = {
	ACCOUNT: {
		ROOT: "/account",
		PROFILE: "/account/profile",
		ADDRESS: "/account/address",
		PAYMENT: "/account/payment",
		ORDER: "/account/order",
		MATERIAL: "/account/material",
		GALLERY: "/account/gallery"
	}
} as const;
